module.exports = __webpack_public_path__ + "img/nav-advances.a52549dc.svg";